import React from 'react';

const ModeSelector = ({ selectedMode, onModeChange }) => {
  return (
    <div className="mode-selector-container">
      <style jsx>{`
        .mode-selector-container {
          margin-bottom: 20px;
        }

        .mode-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          margin-top: 10px;
        }

        .mode-option {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 20px;
          background: #f8fafc;
          border: 3px solid #dee2e6;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
          min-height: 140px;
          justify-content: center;
        }

        .mode-option:hover {
          border-color: #3498db;
          background-color: #e3f2fd;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);
        }

        .mode-option:active {
          transform: translateY(0);
        }

        .mode-option input[type="radio"] {
          position: absolute;
          opacity: 0;
          width: 100%;
          height: 100%;
          margin: 0;
          cursor: pointer;
          z-index: 1;
        }

        .mode-option:has(input[type="radio"]:checked) {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-color: #667eea;
          box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
          transform: translateY(-2px);
        }

        .mode-option input[type="radio"]:focus {
          outline: none;
        }

        .mode-option:has(input[type="radio"]:focus) {
          outline: 3px solid #667eea;
          outline-offset: 2px;
        }

        .mode-icon {
          font-size: 2.5rem;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
          pointer-events: none;
        }

        .mode-option:has(input[type="radio"]:checked) .mode-icon {
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
        }

        .mode-label {
          margin: 0;
          cursor: pointer;
          font-weight: 600;
          font-size: 1.1rem;
          pointer-events: none;
          position: relative;
          z-index: 0;
          text-align: center;
        }

        .mode-description {
          font-size: 0.85rem;
          opacity: 0.8;
          text-align: center;
          margin: 4px 0 0 0;
          pointer-events: none;
        }

        .mode-option:has(input[type="radio"]:checked) .mode-description {
          opacity: 0.9;
        }

        /* Mobile styles */
        @media (max-width: 768px) {
          .mode-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .mode-option {
            padding: 24px 20px;
            min-height: 120px;
          }

          .mode-icon {
            font-size: 2.2rem;
          }

          .mode-label {
            font-size: 1.05rem;
          }

          .mode-description {
            font-size: 0.8rem;
          }
        }
      `}</style>
      
      <div className="form-group">
        <label htmlFor="mode-select"><strong>Select Mode</strong></label>
        <div className="mode-grid">
          <div className="mode-option">
            <input
              type="radio"
              id="mode-upc"
              name="mode"
              value="upc"
              checked={selectedMode === 'upc'}
              onChange={(e) => onModeChange(e.target.value)}
            />
            <span className="mode-icon">🏷️</span>
            <div>
              <div className="mode-label">UPC Mode</div>
              <div className="mode-description">Scan or enter a single UPC</div>
            </div>
          </div>
          
          <div className="mode-option">
            <input
              type="radio"
              id="mode-toso"
              name="mode"
              value="toso"
              checked={selectedMode === 'toso'}
              onChange={(e) => onModeChange(e.target.value)}
            />
            <span className="mode-icon">📦</span>
            <div>
              <div className="mode-label">TO/SO Mode</div>
              <div className="mode-description">Enter Transfer/Sales Order ID</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeSelector;

